export const enum HorizontalOverflowMode {
    WRAP,
    SCROLL,
    CLIP,
}
